export default "__VITE_ASSET__8koLXnwf__"